export const GRID_DAYPARTS = [
  { id: 'overnight', label: 'Overnight', hours: [0, 1, 2, 3, 4, 5] },
  { id: 'morning', label: 'Morning', hours: [6, 7, 8, 9, 10, 11] },
  { id: 'afternoon', label: 'Afternoon', hours: [12, 13, 14, 15, 16, 17] },
  { id: 'evening', label: 'Evening', hours: [18, 19, 20, 21, 22, 23] },
];

export const gridSlotKey = (slot) => `${slot.day_of_week}-${slot.hour}`;

export const slotsInRectangle = (day1, hour1, day2, hour2, isAllowed) => {
  const minDay = Math.min(day1, day2);
  const maxDay = Math.max(day1, day2);
  const minHour = Math.min(hour1, hour2);
  const maxHour = Math.max(hour1, hour2);
  const slots = [];
  for (let day = minDay; day <= maxDay; day++) {
    for (let hour = minHour; hour <= maxHour; hour++) {
      if (!isAllowed || isAllowed(day, hour)) {
        slots.push({ day_of_week: day, hour });
      }
    }
  }
  return slots;
};

export const mergeGridSlots = (base, extra) => {
  const map = new Map(base.map((slot) => [gridSlotKey(slot), slot]));
  extra.forEach((slot) => map.set(gridSlotKey(slot), slot));
  return [...map.values()];
};

export const subtractGridSlots = (base, extra) => {
  const remove = new Set(extra.map(gridSlotKey));
  return base.filter((slot) => !remove.has(gridSlotKey(slot)));
};

export const areAllGridSlotsSelected = (current, candidates) => {
  if (!candidates.length) return false;
  const selected = new Set(current.map(gridSlotKey));
  return candidates.every((slot) => selected.has(gridSlotKey(slot)));
};

export const toggleGridSlotGroup = (current, candidates) => {
  if (areAllGridSlotsSelected(current, candidates)) {
    return subtractGridSlots(current, candidates);
  }
  return mergeGridSlots(current, candidates);
};
